import { IconButton } from '@/components/ats/IconButton';
import { FormBuilder } from '@/components/formBuilder';
import {
  Box,
  Button,
  Flex,
  Icon,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  useDisclosure,
  useOutsideClick,
} from '@chakra-ui/react';
import { XIcon } from '@heroicons/react/solid';
import { useField } from 'formik';
import { useRef } from 'react';
import { FiEdit } from 'react-icons/fi';
import { LuCalendarPlus } from 'react-icons/lu';

const ScheduleBody = ({
  formConfig,
  handleFormSubmit,
  scheduleRef,
  onClose,
  initialValues = {},
}) => {
  return (
    <Flex flexDir="column" gap="20px" p="20px">
      <FormBuilder
        config={formConfig}
        onSubmit={handleFormSubmit}
        formRef={scheduleRef}
        initialValues={initialValues}
      />
      <Flex alignSelf="end" gap="12px">
        <Button onClick={onClose} variant="secondary">
          Cancel
        </Button>
        <Button
          onClick={() => {
            if (scheduleRef?.current) scheduleRef?.current?.submitForm();
          }}
          variant="primary"
          data-test-id="set-schedule-button"
        >
          Set schedule
        </Button>
      </Flex>
    </Flex>
  );
};

export const CustomScheduleAt = () => {
  const [_field, meta, helpers] = useField('schedule_at'); // eslint-disable-line
  const { setValue } = helpers; // eslint-disable-line
  const { isOpen, onClose, onToggle } = useDisclosure();
  const ref = useRef();
  const scheduleRef = useRef();

  useOutsideClick({
    ref: ref,
    handler: () => {
      onClose();
    },
  });

  const formConfig = [
    {
      name: 'schedule_date',
      type: 'date',
      enableTime: true,
      isInline: true,
      disablePreviousDate: true,
      returnWithTimeZoneFormat: true,
    },
  ];

  const handleFormSubmit = (values) => {
    setValue(values?.schedule_date);
    onClose();
  };

  if (meta?.value) {
    return (
      <Flex p="20px 0px" flexDir="column" gap="8px">
        <Text size="sm-medium">Schedule</Text>
        <Flex gap="12px" alignItems="center">
          <Text fontSize="sm">{meta?.value}</Text>
          <Icon
            as={XIcon}
            cursor="pointer"
            onClick={() => {
              setValue(null);
            }}
            ml="-8px"
            w="12px"
            h="12px"
          />
          <Box ref={ref}>
            <Popover isOpen={isOpen} placement="top-start">
              <PopoverTrigger>
                <IconButton
                  type="button"
                  text="Edit schedule"
                  onClick={onToggle}
                  icon={FiEdit}
                />
              </PopoverTrigger>
              <PopoverContent>
                <PopoverBody position="relative">
                  <ScheduleBody
                    formConfig={formConfig}
                    handleFormSubmit={handleFormSubmit}
                    onClose={onClose}
                    scheduleRef={scheduleRef}
                    initialValues={{ schedule_date: meta?.value }}
                  />
                </PopoverBody>
              </PopoverContent>
            </Popover>
          </Box>
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex p="20px 0px" flexDir="column" gap="8px">
      <Text size="sm-medium">Schedule</Text>
      <Box ref={ref}>
        <Popover isOpen={isOpen} placement="top-start">
          <PopoverTrigger>
            <IconButton
              type="button"
              text="Set schedule"
              onClick={onToggle}
              icon={LuCalendarPlus}
              data-test-id="job-stage-email-activity-set-schedule-button"
            />
          </PopoverTrigger>
          <PopoverContent>
            <PopoverBody position="relative">
              <ScheduleBody
                formConfig={formConfig}
                handleFormSubmit={handleFormSubmit}
                onClose={onClose}
                scheduleRef={scheduleRef}
              />
            </PopoverBody>
          </PopoverContent>
        </Popover>
      </Box>
    </Flex>
  );
};
